import React, { useEffect, useState } from 'react';
import columns from '../../../columns/Withdraw.js';
import columnsnew from "../../../columns/WithdrawRequest.js"
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import TableWithSkeleton from '../../../components/global/table/TableWithSkeleton.jsx';
import Pagination from '../../../components/global/pagination/Pagination.jsx';
import Segmented from "../../../components/segmented/Segmented.jsx";
import moment from 'moment/moment.js';
import { GetWithdrawRequestApi, GetWalletApi } from '../../../api/request/client.js';
import Eye from "../../../assets/Eye.jsx";
import ModalComponent from "../../../components/global/modal/ModalComponent.jsx"


const alldata = [
  {
    "name": "BankTransfer",
    "value": "1",
    "fees": 0.0,
    "processingTime": "1 H",
    "paymentLogoUrl": "/assets/images/bank.png"
  },
  {
    "name": "UPI",
    "value": "2",
    "fees": 0.0,
    "processingTime": "1 H",
    "paymentLogoUrl": "/assets/images/upi.png"
  },
  {
    "name": "Paypal",
    "value": "3",
    "fees": 0.0,
    "processingTime": "1 H",
    "paymentLogoUrl": "/assets/images/paypal.png"
  },
  {
    "name": "Crypto",
    "value": "4",
    "fees": 0.0,
    "processingTime": "1 H",
    "paymentLogoUrl": "/assets/images/crypto.png"
  }
];

export default function Withdraw() {
  const navigate = useNavigate();
  const params = useParams();
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [wallet, setWallet] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState('Pending');
  const [data, setData] = useState([]);
  const [datanew, setDatanew] = useState([]);
  const [sorter, setSorter] = useState({ SortBy: 'createdDate', SortOrder: '' });
  const [withdrawdetails, setSelectedcommission] = useState(null);
  const [isOpenModal, setIsOpenModal] = useState(false);


  const handleTableChange = (sorter) => {
    if (sorter?.order) {
      setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
    } else {
      setSorter({ SortBy: 'createdDate', SortOrder: '' });
    }
  };

  const getWallet = async () => {
    try {
      let params = {
        RuleType: 4
      }
      const { data } = await GetWalletApi(id, new URLSearchParams(params).toString());
      if (data?.success) {
        setWallet(data?.data);
      }
    } catch (error) { }
  }

  const getRequests = async () => {
    try {
      setIsLoading(true);
      let apiParams = {
        PageNumber: page,
        PageSize: pageSize,
        FilterText: filter,
        ...sorter
      }
      const { data } = await GetWithdrawRequestApi(params?.id, new URLSearchParams(apiParams).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return ({
              ...item,
              requestDate: item?.requestDate ? moment(item?.requestDate).format('DD-MM-YYYY LT') : null,
              actions: (<div className="flex items-center gap-2">
                <button type="button" onClick={() => { setSelectedcommission(item); setIsOpenModal(true) }}><Eye /></button>
              </div>)
            })
          })
        );
        setTotalRecord(data?.totalItems);
      }
      setIsLoading(false);
    } catch (error) {
      setData([]);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getRequests();
  }, [page, pageSize, sorter]);

  useEffect(() => {
    getWallet();
  }, []);

  useEffect(() => {
    setSearchParams(`filter=${filter}`);
    getRequests();
  }, [filter]);


  const getallwithdraw = () => {

    setDatanew(
      alldata?.map((item) => {
        let route = '';
        if (item?.name === 'BankTransfer') {
          route = `/bank_transfer/${item?.value}/${id}`;
        } else if (item?.name === 'UPI') {
          route = `/upi/${item?.value}/${id}`;
        } else if (item?.name === 'Paypal') {
          route = `/paypal/${item?.value}/${id}`;
        }
        else {
          route = `/crypto/${item?.value}/${id}`;
        }

        return ({
          ...item,
          name: <div className='flex'><img
            src={item?.paymentLogoUrl}
            alt='document-img'
            width={35}
            height={35}
            className=' object-contain'
          /><div className='mt-2 ml-2'>{item?.name}</div></div>,
          status: (
            <button
              className='bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500'
              onClick={() => navigate(route)}
            >
              Withdraw
            </button>
          ),

        });
      })
    );
  }
  useEffect(() => {
    getallwithdraw();
  }, [page, pageSize, filter]);

  return (
    <div>

      <div>
        <div className='border-[2px] border-light rounded-xl pt-4 w-full'>

          <div className='p-4 mb-3 grid grid-cols-2 md:grid-cols-4 gap-5 lg:divide-x'>
            <div>
              <div className='flex justify-center'>
                <p className='text-base font-normal text-center pb-2'>Wallet Account No.</p>
              </div>
              <p className='text-xl primary font-semibold text-center mt-2'>{wallet?.walletAccountNo}</p>
            </div>
            <div>
              <div className='flex justify-center'>
                <p className='text-base font-normal text-center pb-2'>Wallet Balance</p>
              </div>
              <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.walletBalance}</p>
            </div>
            <div>
              <div className='flex justify-center'>
                <p className='text-base font-normal text-center pb-2 '>Minimum Transfer</p>
              </div>
              <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.minAmount || '0'}</p>
            </div>
            <div>
              <div className='flex justify-center'>
                <p className='text-base font-normal text-center pb-2 '>Maximum Transfer</p>
              </div>
              <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.maxAmount || '0'}</p>
            </div>
          </div>
        </div>

        <div className='border-[2px] border-light rounded-xl pt-4 lg:pt-6 w-full mt-5'>
          <div className='my-6'>
            <TableWithSkeleton columns={columns} data={datanew} loading={isLoading} />
            <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
          </div>
        </div>
        <div>
        </div>
      </div>
      <div className='border-[2px] border-light rounded-xl pt-4 lg:pt-6 w-full mt-5'>
        <div className='px-4 lg:px-6'>
          <Segmented options={['Pending', 'Approved', 'Declined']} value={filter} setValue={setFilter} />

        </div>
        <div className='my-6'>
          <TableWithSkeleton columns={columnsnew} data={data} loading={isLoading} onChange={handleTableChange} />
          <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
        </div>
      </div>

      <ModalComponent
        isOpen={isOpenModal}
        setIsOpen={setIsOpenModal}
        title='Withdraw Information'
        width={1300}
      >
        <div className='p-5'>
          <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
            {withdrawdetails?.firstName ? <div>
              <p className='text-base font-normal'>First Name</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.firstName || '---'}</p>
            </div> : ""}
            {withdrawdetails?.lastName ? <div>
              <p className='text-base font-normal'>Last Name</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.lastName || '---'}</p>
            </div> : ""}
            {withdrawdetails?.email ? <div>
              <p className='text-base font-normal'>Email</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.email || '---'}</p>
            </div> : ""}
            {withdrawdetails?.withdrawType ? <div>
              <p className='text-base font-normal'>withdraw Type</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.withdrawType || '---'}</p>
            </div> : ""}
            {withdrawdetails?.walletAccountNo ? <div>
              <p className='text-base font-normal'>Wallet Account No.</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.walletAccountNo || '---'}</p>
            </div> : ""}
            {withdrawdetails?.bankAccountNumber ? <div>
              <p className='text-base font-normal'>Bank Account Number</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.bankAccountNumber || '---'}</p>
            </div> : ""}
            {withdrawdetails?.balance ? <div>
              <p className='text-base font-normal'>Wallet Balance</p>
              <p className='text-xl primary font-semibold mt-2'>$ {withdrawdetails?.balance || '---'}</p>
            </div> : ""}
            {withdrawdetails?.amount ? <div>
              <p className='text-base font-normal'>Amount</p>
              <p className='text-xl primary font-semibold mt-2'>$ {withdrawdetails?.amount || '---'}</p>
            </div> : ""}
            {withdrawdetails?.requestDate ? <div>
              <p className='text-base font-normal'>Created Time</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.requestDate ? moment(withdrawdetails?.requestDate).format('DD-MM-YYYY, hh:mm A') : '---'}</p>
            </div> : ""}
            {withdrawdetails?.requestStatus === "Pending" ? "" : <div>
              <p className='text-base font-normal'>Action Time</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.actionDate ? moment(withdrawdetails?.actionDate).format('DD-MM-YYYY, hh:mm A') : '---'}</p>
            </div>}
            {withdrawdetails?.bankBranchAddress ? <div>
              <p className='text-base font-normal'>Bank Branch Address</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.bankBranchAddress || '---'}</p>
            </div> : ""}
            {withdrawdetails?.bankName ? <div>
              <p className='text-base font-normal'>Bank Name</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.bankName || '---'}</p>
            </div> : ""}
            {withdrawdetails?.iban ? <div>
              <p className='text-base font-normal'>IBAN</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.iban || '---'}</p>
            </div> : ""}
            {withdrawdetails?.ifscCode ? <div>
              <p className='text-base font-normal'>IBAN Number</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.ifscCode || '---'}</p>
            </div> : ""}
            {withdrawdetails?.swifT_BIC_Code ? <div>
              <p className='text-base font-normal'>SwifT BIC Code</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.swifT_BIC_Code || '---'}</p>
            </div> : ""}
            {withdrawdetails?.cryptoWalletAddress ? <div>
              <p className='text-base font-normal'>Crypto Wallet Address</p>
              <div className="flex items-center gap-3">
                <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.cryptoWalletAddress || '---'}</p>
                
              </div>
            </div> : ""}
            {withdrawdetails?.paypalEmail ? <div>
              <p className='text-base font-normal'>Paypal Email</p>
              <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.paypalEmail || '---'}</p>
            </div> : ""}
            {withdrawdetails?.upiId ? <div>
              <p className='text-base font-normal'>UPI Id</p>
              <div className="flex items-center gap-3">
                <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.upiId || '---'}</p>
                {/* <Copy text={withdrawdetails?.upiId} /> */}
              </div>
            </div> : ""}
            {withdrawdetails?.requestStatus === "Rejected" ? <div>
              <p className='text-base font-normal'>Comment</p>
              <div className="flex items-center gap-3">
                <p className='text-xl primary font-semibold mt-2'>{withdrawdetails?.comment || '---'}</p>
              </div>
            </div> : ""}

          </div>
        </div>

      </ModalComponent>
    </div >
  )
}